import { render, staticRenderFns } from "./PickRec.vue?vue&type=template&id=1b210ec7&scoped=true&"
import script from "./PickRec.vue?vue&type=script&lang=js&"
export * from "./PickRec.vue?vue&type=script&lang=js&"
import style0 from "./PickRec.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PickRec.vue?vue&type=style&index=1&id=1b210ec7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b210ec7",
  null
  
)

export default component.exports